import Container, { ContainerProps } from "./Container";
import styles from "./Container.module.scss";

export interface InnerContentContainerProps extends ContainerProps {
  borderLeft?: boolean;
  borderRight?: boolean;
  borderBottom?: boolean;
  borderTop?: boolean;
}

export default function InnerContainer({
  borderLeft = false,
  borderRight = false,
  borderTop = false,
  borderBottom = false,
  ...props
}: InnerContentContainerProps) {
  return (
    <Container
      {...props}
      className={`${props.className} ${styles.inner} ${borderLeft ? styles["border-left"] : ""} ${
        borderRight ? styles["border-right"] : ""
      } ${borderTop ? styles["border-top"] : ""} ${borderBottom ? styles["border-bottom"] : ""}`}
    />
  );
}
